export default __webpack_public_path__ + "static/media/open-link-green.a632debc.svg";